import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { PlayerProvider } from './contexts/PlayerContext';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ShoutcastPlayer from './components/common/ShoutcastPlayer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Events from './pages/Events';
import ProtectedRoute from './routes/ProtectedRoute';
import TechBackground from './components/common/TechBackground';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

function App() {
  const location = useLocation();
  return (
    <AuthProvider>
      <PlayerProvider>
        <Box sx={{
          minHeight: '100vh',
          position: 'relative',
          bgcolor: '#0A0A0E',
          color: 'white'
        }}>
          {/* Camada de background fixa com aceleração por hardware - elimina repaints no scroll */}
          <Box
            sx={{
              position: 'fixed',
              inset: 0,
              backgroundImage: 'linear-gradient(to bottom, rgba(10, 10, 14, 0.75) 0%, rgba(10, 10, 14, 0.90) 100%), url(/img/bg_cyber.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              pointerEvents: 'none',
              zIndex: 0,
              transform: 'translateZ(0)',
              willChange: 'transform',
            }}
          />
          <Box
            sx={{
              position: 'fixed',
              inset: 0,
              background: 'radial-gradient(ellipse at center, rgba(10, 10, 14, 0.3) 0%, rgba(10, 10, 14, 0.85) 100%)',
              pointerEvents: 'none',
              zIndex: 0,
              transform: 'translateZ(0)',
            }}
          />
          <Header />
          <TechBackground />

          <Box component="main" sx={{
            minHeight: 'calc(100vh - 140px)',
            paddingTop: '80px', // Account for fixed header
            position: 'relative',
            overflow: 'hidden',
            zIndex: 5
          }}>
            <Box
              key={location.pathname}
              sx={{
                animation: 'fadeIn 150ms ease-out',
                '@keyframes fadeIn': {
                  from: { opacity: 0 },
                  to: { opacity: 1 },
                },
              }}
            >
              <Routes location={location}>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route path="/events" element={<Events />} />
                <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/termos-de-servico" element={<TermsOfService />} />
                <Route path="/terms" element={<TermsOfService />} />
              </Routes>
            </Box>
          </Box>

          <Footer />
          <ShoutcastPlayer />
        </Box>
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
